import React from "react";
import { useTranslation } from "react-i18next";

import { makeStyles } from "tss-react/mui";

import { useNavigate } from "react-router-dom";

const useStyles = makeStyles()((theme) => ({
	main: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	header: {
		fontSize: "40px",
	},
	para: {
		textAlign: "center",
		cursor: "pointer",
	},
}));

const PageNotFound = ({ message }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { classes, } = useStyles();
	const handleGoBack = () => navigate(-1);
	const resolvedMessage = message ?? t("message.pageNotFound404");

	return (
		<div className={classes.main}>
			<div>
				<h1 className={classes.header}>{resolvedMessage}</h1>

				<p onClick={handleGoBack} className={classes.para}>
					{t("action.goBack")}
				</p>
			</div>
		</div>
	);
};

export default PageNotFound;
